const MODULE_URL = 'web_users';

export default {
  MODULE_URL: MODULE_URL,
  USERS_URL: MODULE_URL,

  ADDED: 'web_user_added',
  UPDATED: 'web_user_updated',
  REMOVED: 'web_user_removed',
};
